module.exports = __webpack_public_path__ + "img/sxsjs2.65e2f189.png";